import { render, staticRenderFns } from "./module-loading.vue?vue&type=template&id=63e776ba&"
import script from "./module-loading.vue?vue&type=script&lang=js&"
export * from "./module-loading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports